export default [
  {
    icon: 'mdi-pencil',
    title: 'Ubah Laporan',
    event: 'onEdit',
  },
];
